import { render, staticRenderFns } from "./Transportadoras.vue?vue&type=template&id=344df5bc"
import script from "./Transportadoras.vue?vue&type=script&lang=js"
export * from "./Transportadoras.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports